module.exports = __webpack_public_path__ + "img/chess7.ca1690e2.png";